import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import VuexPersistence from 'vuex-persist';
import getters from './getters';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    storage: window.sessionStorage,
    modules: ['app']
});

const store = new Vuex.Store({
  modules: {
    app
  },
  getters,
  plugins: [vuexLocal.plugin]
});

export default store;
